export const config = {
  api: {
    root: "https://loa-language-school.herokuapp.com",
  },
  firebase: {
    apiKey: "AIzaSyCUHKJ0XCIQpG2TfU6zAmuswLq8-xKGMN4",
    authDomain: "loa-language-school.firebaseapp.com",
    databaseURL:
      "https://loa-language-school-default-rtdb.europe-west1.firebasedatabase.app",
    projectId: "loa-language-school",
    storageBucket: "loa-language-school.appspot.com",
    messagingSenderId: "834943372338",
    appId: "1:834943372338:web:f3d0de5295ff609ce5802b",
  },
};
